export const ColorLookup = {
    KL2: "#8884d8",
    K01: "#82ca9d",
    K08: "#68affc",
    K12: "#ffa500",
    K23: "#fa8072",
    KCOMP: '#7f7f7f'
}



export const GenderColorLookup = { "Female": '#f15f36', 'Male': '#19a0aa', 'Unknown': '#7f7f7f' }


export function percentageFormat(decimal) {
    return `${decimal.toFixed(1)}%`;
}

export function decimalFormat(decimal) {
    return Math.round(decimal);
}

export function getAvailableGroup(awardTotal) {
    return awardTotal.filter(group => group.n !== 0 && group.study_award !== 'KL2').map(group => group.study_award);
}

export function getNewComparisonGroup(oldGroup, selectedAward) {
    return oldGroup.includes(selectedAward)
        ? [...oldGroup].filter(award => award !== selectedAward)
        : [...oldGroup, selectedAward];
}

export function transformCareerData(rawData) {

    let careerData = rawData.map(item => ({ [item.study_award]: item.n, occ: item.ctsa_occ_type, year: item.year_since_k }));

    let clinical = [];
    let research = [];
    let tenure = [];
    let other = [];
    for (let i = 0; i <= 5; i++) {
        clinical.push(Object.assign({}, ...careerData.filter(item => item.occ === "Clinical Faculty" && item.year === i)));
        research.push(Object.assign({}, ...careerData.filter(item => item.occ === "Research Faculty" && item.year === i)));
        tenure.push(Object.assign({}, ...careerData.filter(item => item.occ === 'Tenure-Track Faculty' && item.year === i)));
        other.push(Object.assign({}, ...careerData.filter(item => item.occ === 'Other' && item.year === i)));
    }


    careerData = [...tenure, ...research, ...clinical, ...other];
    return careerData;


}


export function transformAwardData(rawData) {
    let awardData = [];
    for (let i = 1; i <= 10; i++) {
        awardData.push(Object.assign({}, ...rawData.map(item => ({ year: item.year_since_k, [item.study_award]: item.n })).filter(item => item.year === i)))

    }

    return awardData;


}

export function transformTotals(raw) {
    return raw.reduce((obj, item) => (obj[item.study_award] = item.n, obj), {})
}

export function sumComparisonGroup(awardTotal, compareGroup) {
    return compareGroup.reduce((acc, cur) => acc + awardTotal[cur], 0)
}

export function filterCareerData(careerData, selectedYear, compareGroup) {
    let careerDataOfSelectedYear = getCareerOfSelectedYear(careerData, selectedYear);

    return careerDataOfSelectedYear.map((item, i, arr) => ({
        occ: item.occ,
        ...['KL2', ...compareGroup].reduce((acc, award) => {

            return { ...acc, ...{ [award]: 100 * item[award] / getSelectedYearTotal(arr, award) } };
        }, {})
    }));


}

export function getCareerOfSelectedYear(careerData, selectedYear) {
    return careerData.filter(item => item.year === selectedYear);

}

export function getSelectedYearTotal(careerDataofSelectedYear, award) {
    return careerDataofSelectedYear.reduce((acc, cur) => cur[award] ? acc + cur[award] : acc, 0);
}

export function getIndicator(careerDataSelectedYear, compareGroup) {

    const indicatorOccGroup = careerDataSelectedYear.filter(item => item.occ === 'Tenure-Track Faculty' || item.occ === 'Research Faculty');
    const KL2Indicator = 100 * getSelectedYearTotal(indicatorOccGroup, "KL2") / getSelectedYearTotal(careerDataSelectedYear, 'KL2');
    let KCOMPIndicator;
    if (compareGroup.length === 0) {
        KCOMPIndicator = 0;
    } else {
        KCOMPIndicator = 100 * compareGroup.reduce((acc, award) => acc += getSelectedYearTotal(indicatorOccGroup, award), 0) / compareGroup.reduce((acc, award) => acc += getSelectedYearTotal(careerDataSelectedYear, award), 0);

    }

    return { KL2Indicator, KCOMPIndicator };

}

export function filterAwardData(awardData, compareGroup, awardTotal) {
    return awardData.filter(item => item.year <= 5).map(
        item => ({
            year: item.year,
            KCOMP: 100 * compareGroup.reduce((acc, cur) => acc + item[cur], 0) / compareGroup.reduce((acc, cur) => acc + awardTotal[cur], 0),
            ...['KL2', ...compareGroup].reduce((acc, cur) => ({ ...acc, ...{ [cur]: 100 * item[cur] / awardTotal[cur] } }), {})

        }));


}

export function getNodesTotal(awardPathwayNullDropped, award) {
    return awardPathwayNullDropped.filter(path => path.path_source === award).reduce((acc, cur) => acc += cur.n, 0)
}

export function getNodeId(nodes, sourceOrTarget) {
    return nodes.filter(node => node.name === sourceOrTarget)[0].id;
}

export function generateSankeyData(awardPathway, comparisonGroup) {

    const startingNodes = ['KL2', ...comparisonGroup];
    //drop meaningless data points (study_award and path_source are different and target is null). Matt will redo the table later
    const awardPathwayNullDropped = awardPathway.filter(path => !(path.path_target === null && path.study_award !== path.path_source) && startingNodes.includes(path.study_award));

    const startingNodesAvailable = awardPathwayNullDropped.filter(path => path.path_target === null).map(path => path.study_award);

    const sourceNodes = awardPathwayNullDropped.map(path => path.path_source);
    const targetNodes = awardPathwayNullDropped.map(path => path.path_target).filter(node => node)//need to filter out null node
    const startingNodesLookup = startingNodes.reduce((acc, node) => ({ ...acc, ...{ [node]: `${node} (n=${getNodesTotal(awardPathwayNullDropped, node)})` } }), {});

    const awardsAfterK = [...new Set([...sourceNodes, ...targetNodes])].filter(node => !startingNodes.includes(node));
    const nodes = [...Object.values(startingNodesLookup), ...startingNodes, ...awardsAfterK].map((node, i) => ({ name: node, id: i }));
    let links = awardPathwayNullDropped.map(path => ({ source: path.path_target ? getNodeId(nodes, path.path_source) : getNodeId(nodes, startingNodesLookup[path.study_award]), target: path.path_target ? getNodeId(nodes, path.path_target) : getNodeId(nodes, path.path_source), value: path.path_target ? path.n : getNodesTotal(awardPathwayNullDropped, path.study_award) }));

    //exception for Pittsburg
    let missingStartingnode;
    if (startingNodesAvailable.length < startingNodes.length) {
        missingStartingnode = startingNodes.filter(node => !startingNodesAvailable.includes(node))[0];
        links.push({ source: getNodeId(nodes, startingNodesLookup[missingStartingnode]), target: getNodeId(nodes, missingStartingnode), value: getNodesTotal(awardPathwayNullDropped, missingStartingnode) })
    }

    function groupBy(array, f) {
        var groups = {};
        array.forEach(function (o) {
            var group = JSON.stringify(f(o));
            groups[group] = groups[group] || [];
            groups[group].push(o);
        });
        return Object.keys(groups).map(function (group) {
            return groups[group];
        })
    }

    const result = groupBy(links, function (item) {
        return [item.source, item.target];
    });

    links = result.map(group => { return { source: group[0].source, target: group[0].target, value: group.reduce((acc, cur) => acc += cur.value, 0) } });

    return { nodes, links }
}



export function filterPatentNumber(patentNumber, patentSector, compareGroup, awardTotal) {

    let KL2PatentCount, KCOMPPatentCount;
    let KL2ScholarPercentage, KCOMPScholarPercentage;
    let KL2TopSector, KCOMPTopSector;
    KL2PatentCount = patentNumber.filter(item => item.study_award === "KL2")[0].n_patents || 'NA';
    KL2ScholarPercentage = (patentNumber.filter(item => item.study_award === "KL2")[0].n_inventors)
        ? `${((100 * patentNumber.filter(item => item.study_award === "KL2")[0].n_inventors) / awardTotal.KL2).toFixed(1)}%`
        : 'NA';
    if (patentSector.filter(item => item.study_award === "KL2").length) {
        const { sector_title: KL2Sector, field_title: KL2Field } = patentSector.filter(item => item.study_award === "KL2").sort((a, b) => b.n_patents - a.n_patents)[0];
        KL2TopSector = `${KL2Sector} (${KL2Field})`;
    } else {
        KL2TopSector = 'NA';
    }

    if (compareGroup.length === 0) {
        KCOMPPatentCount = 'NA';
        KCOMPScholarPercentage = 'NA';
        KCOMPTopSector = 'NA';
    } else {
        KCOMPPatentCount = compareGroup.reduce((acc, cur) => acc += patentNumber.filter(item => item.study_award === cur)[0].n_patents, 0) !== 0
            ? compareGroup.reduce((acc, cur) => acc += patentNumber.filter(item => item.study_award === cur)[0].n_patents, 0)
            : 'NA';
        KCOMPScholarPercentage = compareGroup.reduce((acc, cur) => acc += patentNumber.filter(item => item.study_award === cur)[0].n_inventors, 0) !== 0
            ?`${ (100*compareGroup.reduce((acc, cur) => acc += patentNumber.filter(item => item.study_award === cur)[0].n_inventors, 0) / sumComparisonGroup(awardTotal, compareGroup)).toFixed(1)}%`
            : 'NA';

        if (patentSector.filter(item => compareGroup.includes(item.study_award)).length) {
            const { sector_title: KCOMPSector, field_title: KCOMPField } = patentSector.filter(item => compareGroup.includes(item.study_award)).sort((a, b) => b.n_patents - a.n_patents)[0];
            KCOMPTopSector = `${KCOMPSector} (${KCOMPField})`;
        } else {
            KCOMPTopSector = 'NA';
        }
    }
    return { KL2PatentCount, KCOMPPatentCount, KL2ScholarPercentage, KCOMPScholarPercentage, KL2TopSector, KCOMPTopSector };
}

export function filterBibs(bibs, compareGroup, awardTotal) {
    const { first_author: KL2First, last_author: KL2Last, total_author_count: KL2TotalAuthor, n_pubs: KL2NPubs } = bibs.filter(item => item.study_award === 'KL2')[0]
    const KL2AvgPub = (KL2NPubs / awardTotal.KL2).toFixed(1);
    const KL2AvgAuthorPerPub = (KL2TotalAuthor / KL2NPubs).toFixed(1);
    const KL2FirstPerc = `${(100 * KL2First / KL2NPubs).toFixed(1)}%`
    const KL2LastPerc = `${(100 * KL2Last / KL2NPubs).toFixed(1)}%`
    const KCOMPTotal = sumComparisonGroup(awardTotal, compareGroup);
    const KCOMPNPubs = compareGroup.reduce((acc, cur) => acc += bibs.filter(item => item.study_award === cur)[0].n_pubs, 0);
    const KCOMPTotalAuthor = compareGroup.reduce((acc, cur) => acc += bibs.filter(item => item.study_award === cur)[0].total_author_count, 0);
    const KCOMPFirstAuthor = compareGroup.reduce((acc, cur) => acc += bibs.filter(item => item.study_award === cur)[0].first_author, 0);
    const KCOMPLastAuthor = compareGroup.reduce((acc, cur) => acc += bibs.filter(item => item.study_award === cur)[0].last_author, 0);
    let KCOMPAvgPub, KCOMAvgAuthorPerPub, KCOMPFirstPerc, KCOMPLastPerc;
    if (compareGroup.length === 0) {
        KCOMPAvgPub = 'NA';
        KCOMAvgAuthorPerPub = 'NA';
        KCOMPFirstPerc = 'NA';
        KCOMPLastPerc = 'NA';
    } else {
        KCOMPAvgPub = (KCOMPNPubs / KCOMPTotal).toFixed(1);
        KCOMAvgAuthorPerPub = (KCOMPTotalAuthor / KCOMPNPubs).toFixed(1);
        KCOMPFirstPerc = `${(100 * KCOMPFirstAuthor / KCOMPNPubs).toFixed(1)}%`;
        KCOMPLastPerc = `${(100 * KCOMPLastAuthor / KCOMPNPubs).toFixed(1)}%`;
    }

    return { KL2AvgPub, KL2AvgAuthorPerPub, KL2FirstPerc, KL2LastPerc, KCOMPAvgPub, KCOMAvgAuthorPerPub, KCOMPFirstPerc, KCOMPLastPerc };
}

export function getTopJournals(journals, compareGroup): { KL2TopJournals: string[], KCOMPTopJournals: string[] } {
    let result = {
        KL2TopJournals: [],
        KCOMPTopJournals: []
    }
    //sort by impact factor later
    result.KL2TopJournals = journals.filter(item => item.study_award === 'KL2').sort((a, b) => b.n_pubs - a.n_pubs).slice(0, 5).map(item => item.journal_title);

    let KCOMPTopJournals = journals.filter(item => compareGroup.includes(item.study_award));

    // function to remove duplicated journals from the list of journal
    function filterTopJournals(journalList, key) {
        return [
            ...new Map(
                journalList.map(journal => [key(journal), journal])
            ).values()
        ]
    }

    if (KCOMPTopJournals.length === 0) {
        KCOMPTopJournals = false
    } else {
        // call to remove duplicates using journal title as a key
        KCOMPTopJournals = filterTopJournals(KCOMPTopJournals.slice(0,50), journal => journal.journal_title);

        KCOMPTopJournals = KCOMPTopJournals
            .sort((a, b) => b.n_pubs - a.n_pubs)
            .slice(0, 5)
            .map(item => item.journal_title);
    }
    result.KCOMPTopJournals = KCOMPTopJournals;
    return result;
}

export function getTopMeshTerms(mesh) {
    const KL2Mesh = mesh.filter(item => item.study_group === 'KL2').sort((a, b) => b.ingroup_rank - a.ingroup_rank).map(item => item.mesh);
    let KCOMPMesh = mesh.filter(item => item.study_group !== 'KL2');
    if (KCOMPMesh[0].mesh === null) {
        KCOMPMesh = false;
    } else {
        KCOMPMesh = KCOMPMesh.sort((a, b) => b.ingroup_rank - a.ingroup_rank).map(item => item.mesh);
    }

    return { KL2Mesh, KCOMPMesh }
}

export function getTeam(team, compareGroup) {
    const occGroup = ["Faculty", "Clinical", "Post Docs", "Staff", "Students"];
    const KL2PI = team.filter(item => item.study_award === 'KL2' && item.is_PI === 1);
    const KL2Any = team.filter(item => item.study_award == 'KL2' && item.is_PI === 0);
    const KCOMPPI = team.filter(item => compareGroup.includes(item.study_award) && item.is_PI === 1);
    const KCOMPAny = team.filter(item => compareGroup.includes(item.study_award) && item.is_PI === 0);
    const KL2PITotal: number = KL2PI[0].n_scholars;
    const KL2AnyTotal = KL2Any[0].n_scholars;
    const KCOMPPITotal = compareGroup.reduce((acc, cur) => acc += KCOMPPI.find(item => item.study_award === cur).n_scholars, 0);
    const KCOMPAnyTotal = compareGroup.reduce((acc, cur) => acc += KCOMPAny.find(item => item.study_award === cur).n_scholars, 0);

    const [KL2PIFaculty, KL2PIClinician, KL2PIPostdoc, KL2PIStaff, KL2PIStudents] = occGroup.map(occ => getOccComposition(KL2PI, KL2PITotal, occ));
    const [KL2AnyFaculty, KL2AnyClinician, KL2AnyPostdoc, KL2AnyStaff, KL2AnyStudents] = occGroup.map(occ => getOccComposition(KL2Any, KL2AnyTotal, occ));
    const [KCOMPAnyFaculty, KCOMPAnyClinician, KCOMPAnyPostdoc, KCOMPAnyStaff, KCOMPAnyStudents] = getTeamMembers(KCOMPAny, KCOMPAnyTotal, occGroup);
    const [KCOMPPIFaculty, KCOMPPIClinician, KCOMPPIPostdoc, KCOMPPIStaff, KCOMPPIStudents] = getTeamMembers(KCOMPPI, KCOMPPITotal, occGroup);

    const KL2PIClinicianPercentage =getClinicianBulletPoints(KL2PI, KL2PITotal);
    const KL2AnyClinicianPercentage = getClinicianBulletPoints(KL2Any,KL2AnyTotal);
    const KCOMPPIClinicianPercentage = getClinicianBulletPoints(KCOMPPI, KCOMPPITotal);
    const KCOMPAnyClinicianPercentage = getClinicianBulletPoints(KCOMPAny, KCOMPAnyTotal);

    return {
        KL2PITotal, KL2AnyTotal, KCOMPPITotal, KCOMPAnyTotal,
        KL2PIFaculty, KL2PIClinician, KL2PIPostdoc, KL2PIStaff, KL2PIStudents,
        KL2AnyFaculty, KL2AnyClinician, KL2AnyPostdoc, KL2AnyStaff, KL2AnyStudents,
        KCOMPAnyFaculty, KCOMPAnyClinician, KCOMPAnyPostdoc, KCOMPAnyStaff, KCOMPAnyStudents,
        KCOMPPIFaculty, KCOMPPIClinician, KCOMPPIPostdoc, KCOMPPIStaff, KCOMPPIStudents,
        KL2PIClinicianPercentage, KL2AnyClinicianPercentage, KCOMPPIClinicianPercentage, KCOMPAnyClinicianPercentage
    };
}

export function getTeamMembers(filteredTeam, filteredTeamTotal, occGroup) {
    if (filteredTeamTotal < 5) {
        return Array(5).fill('NA');
    } else {
        return occGroup.map(occ => getOccComposition(filteredTeam, filteredTeamTotal, occ));
    }
}

export function getOccComposition(filteredTeam, filteredTeamTotal, occ) {
    if (filteredTeamTotal === 0) {
        return 'NA';
    } else {
        return filteredTeam.filter(item => item.ctsa_occ_class === occ).reduce((acc, cur) => acc += cur.total_employed_in_class, 0) / filteredTeamTotal;

    }

}

export function getClinicianBulletPoints(filteredTeam,filteredTeamTotal) {
    if (filteredTeamTotal === 0) {
        return 'NA';
    } else {
        const clinician = filteredTeam.filter(item => item.ctsa_occ_class === 'Clinical');
        return `${(100 * clinician.reduce((acc, cur) => acc += cur.scholars_with_any_in_class, 0) / filteredTeamTotal).toFixed(1)}%`;
    }
}

export function getTeamGender(teamGender, compareGroup) {

    const KL2Any = teamGender.filter(item => item.study_award === 'KL2' && item.is_PI === 0);
    const KL2PI = teamGender.filter(item => item.study_award === 'KL2' && item.is_PI === 1);
    const KCOMPPI = teamGender.filter(item => compareGroup.includes(item.study_award) && item.is_PI === 1);
    const KCOMPAny = teamGender.filter(item => compareGroup.includes(item.study_award) && item.is_PI === 0);

    return {
        KL2AnyGender: calculateGenderPercentage(KL2Any),
        KCOMPAnyGender: calculateGenderPercentage(KCOMPAny),
        KL2PIGender: calculateGenderPercentage(KL2PI),
        KCOMPPIGender: calculateGenderPercentage(KCOMPPI)
    }


}
export function calculateGenderPercentage(genderArr) {
    let maleTotal = 0;
    let femaleTotal = 0;
    let unknownTotal = 0;
    let nTotal = 0;
    genderArr.forEach(award => {
        maleTotal += award.teams_men;
        femaleTotal += award.teams_women;
        unknownTotal += award.teams_gender_unknown;
        nTotal += award.n_team_members;
    });
    if (nTotal === 0) {
        return [{ name: 'Female', value: 0 }, { name: 'Male', value: 0 }, {
            name: 'Unknown', value: 0
        }]
    } else {
        return [{ name: 'Female', value: 100 * femaleTotal / nTotal }, { name: 'Male', value: 100 * maleTotal / nTotal }, {
            name: 'Unknown', value: 100 * unknownTotal / nTotal
        }]
    }

}

